import { jsx as _jsx } from "react/jsx-runtime";
import { getCNPJFormatado } from '../../../utils';
import { getInstituicoes } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'razao_social', headerName: 'Razão Social', width: 300 },
    {
        field: 'cnpj',
        headerName: 'CNPJ',
        width: 250,
        valueGetter: function (value) { return "".concat(getCNPJFormatado(value)); },
    },
    { field: 'nome_fantasia', headerName: 'Nome Fantasia', width: 300 },
    { field: 'responsavel_nome', headerName: 'Responsável', width: 250 },
];
export default function Instituicoes() {
    return (_jsx(GridBase, { pagina: PAGINAS.CC_INSTITUICOES, paginaPermissao: FUNCIONALIDADES.CC_INSTITUICOES, rota: ROUTES.CC_INSTITUICOES, fetchData: function (txt, _filter, pag) { return getInstituicoes(txt, pag); }, columns: COLUNAS }));
}
